import { Theme } from "../../const/preAuthConsts";
import ApiInstance from "../../api/ApiInstance";
import { setConnectedLoadingContextElement } from "../../components/common/LoadingContainer/ConnectedLoadingContainer";
import { invokeApiMethod } from "../invokeApiMethod";
import * as preAuthActionTypes from "./preAuthActionTypes";

const restoreLoginSuccess = ({ user_details }) => ({
    type: preAuthActionTypes.SET_USERNAME,
    username: user_details.username,
});
// TODO: get username from somewhere else and use isLoggedIn for checking initial login state
export const restoreLogin = () => invokeApiMethod("restoreLogin", [], restoreLoginSuccess, undefined, true);

// Theme Actions
export const setDarkMode =
    (isDarkMode: boolean, store = false) =>
    dispatch => {
        const theme = isDarkMode ? Theme.DARK : Theme.LIGHT;
        dispatch({
            type: preAuthActionTypes.SET_DARK_MODE,
            theme: theme,
        });
        if (store) return ApiInstance.api.updateUserPreferences({ theme });
    };

// UI actions
const setLoading = (currentlyLoading: boolean | string, contextElement: HTMLElement) => {
    setConnectedLoadingContextElement(contextElement);
    return { type: preAuthActionTypes.CURRENTLY_LOADING, currentlyLoading };
};
export const startLoading = setLoading;
export const endLoading = () => setLoading(undefined, undefined);
